export default __webpack_public_path__ + "static/item_08-fef231db91e745646d50b8e36f6f064b.jpg";